export const RESERVED_ROOT_PATHS = [
  "api",
  "bio",
  "songs",
  "albums",
  "videos",
  "redirect",
  "r",
  "admin",
  "newsletter",
  "members",
  "branches",
  "merch",
  "games",
] as const;

const reservedRootPathSet = new Set<string>(RESERVED_ROOT_PATHS);

export const isReservedRootPath = (value?: string | null): boolean =>
  Boolean(value && reservedRootPathSet.has(value.toLowerCase()));

export const getRouteArtistSlug = (parts: string[], fallback = "truevined"): string => {
  const firstPart = parts[0]?.toLowerCase();
  return firstPart && !isReservedRootPath(firstPart) ? firstPart : fallback;
};

const RELEASE_SEGMENTS = new Set(["songs", "albums"]);
const ARTIST_SUBPAGES = new Set(["bio", "songs", "albums", "videos"]);

export interface ReleaseRoute {
  artist: string;
  releaseName: string;
}

export const releaseRouteFromPath = (pathname: string): ReleaseRoute | null => {
  const parts = pathname.split("/").filter(Boolean).map((part) => decodeURIComponent(part));
  if (parts.length === 2 && RELEASE_SEGMENTS.has(parts[0].toLowerCase())) {
    return { artist: "truevined", releaseName: parts[1] };
  }
  if (parts.length === 3 && RELEASE_SEGMENTS.has(parts[1].toLowerCase()) && !isReservedRootPath(parts[0])) {
    return { artist: parts[0], releaseName: parts[2] };
  }
  if (parts.length === 2 && !isReservedRootPath(parts[0]) && !ARTIST_SUBPAGES.has(parts[1].toLowerCase())) {
    return { artist: parts[0], releaseName: parts[1] };
  }
  return null;
};

export const isReleasePath = (pathname: string): boolean => releaseRouteFromPath(pathname) !== null;
